// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import { getNotifyStyle } from "@turnerBlueprint/App/Components/Notify";
import { recentWishListsStyles } from "@turnerBlueprint/Overrides/Widgets/Common/RecentWishLists";
import { color, mergeWithCss, xScreen } from "@turnerBlueprint/XDL/Utilities";
import { css } from "styled-components";

recentWishListsStyles.wishListCard = {
    actionAddToCartButton: {
        variant: "primary",
        color: "primary",
        typographyProps: {
            size: 14,
        },
    },
    sharingStatusGridItem: {
        width: [12, 12, 12, 4, 4],
    },
    detailLinkGridItem: {
        css: css`
            a span {
                font-size: 16px;
                letter-spacing: 0;
                line-height: 17px;
            }
        `,
    },
    sharingStatus: {
        privateTooltip: {
            iconProps: {
                css: css`
                    &&&& {
                        margin-left: 0;
                    }
                `,
            },
            cssOverrides: {
                tooltipClickable: css`
                    &&& {
                        ${IconWrapper} {
                            color: ${color("common.ui8")};
                        }
                    }
                `,
            },
        },
    },
    wishListInfoGridItem: {
        width: [12, 12, 12, 4, 4],
    },
    extendedInfoGridItem: {
        width: [12, 12, 12, 6, 6],
    },
};

recentWishListsStyles.noWishListsText = {
    ...mergeWithCss(getNotifyStyle("info", true), {
        css: css`
            margin: 0;
        `,
    }),
};

recentWishListsStyles.cardListStyles = {
    gridContainer: {
        gap: 0,
        offsetCss: css`
            justify-content: space-between;
        `,
        css: css`
            &&& {
                padding-right: 0;
                padding-left: 0;

                ${({ isOdd }: any) =>
                    isOdd &&
                    css`
                        ${xScreen("lte", "md")} {
                            .card_container__wrapper:nth-last-of-type(2) {
                                border-bottom: 1px solid ${color("common.border")};
                            }
                        }
                    `}
            }
        `,
    },
};

recentWishListsStyles.cardContainer = {
    cardDivider: {
        css: css`
            margin: 0 0 16px 0;
            padding-bottom: 16px;
            width: 100%;

            &:not(:last-child) {
            }

            ${xScreen("lte", "md")} {
                width: calc(50% - 20px);

                &:nth-last-of-type(-n + 2) {
                    border-bottom: none;
                }
            }

            ${xScreen("lt", "sm")} {
                width: 100%;

                &,
                &:nth-last-of-type(-n + 2) {
                    border-bottom: 1px solid ${color("common.border")};
                }

                &:last-of-type {
                    border-bottom: none;
                }
            }
        `,
    },
    gridItem: {
        width: 12,
        css: css`
            padding: 0px;
        `,
    },
};

recentWishListsStyles.noWishListsGridItem = {
    css: css`
        width: 100%;
        padding-top: 16px;
        border-top: 1px solid ${color("common.border")};
    `,
};
